import {useStorageItemValue} from "@variocube/cube-ui";
import {Item, Rental, RentalState, RentalTypes, Tenant, User} from "./types";

export function useTenant() {
    return useStorageItemValue<Tenant>('tenant');
}

export function useRentals() {
    return useStorageItemValue<Rental[]>("rentals") || [];
}

export function useItems() {
    return useStorageItemValue<Item[]>("items") || [];
}

export function useItemsForInspection() {
    return useStorageItemValue<string[]>("itemsForInspection") ?? [];
}

export function useUsers() {
    return useStorageItemValue<User[]>("users") ?? [];
}

export function useRentalTypes() {
    return useStorageItemValue<RentalTypes>("rentalTypes");
}

export function useItem(itemUuid?: string) {
    return useItems().find(item => item.uuid == itemUuid);
}

export function useCurrentRental(item: string) {
    return findCurrentItemRental(useRentals(), item);
}

export function findCurrentItemRental(rentals: Rental[], itemUuid: string) {
    return rentals
        .filter(isCurrent)
        .find(rental => rental.itemUuid == itemUuid);
}

export function getStatus(rental: Rental) {
    const {from, until} = rental;
    const now = new Date();
    return {
        expired: now >= new Date(until),
        started: now >= new Date(from)
    }
}

export function isCurrent(rental: Rental) {
    const {expired, started} = getStatus(rental);
    return started && !expired;
}

export function isDelayed(rental: Rental): boolean {
    switch (rental.state) {
        case RentalState.BorrowerPickedUp:
        case RentalState.LenderReturned:
            const {started, expired} = getStatus(rental);
            return started && expired && Boolean(rental.borrower.rentalEndsAfterReturn);
        default:
            return false;
    }
}